module.exports = __webpack_public_path__ + "img/daily.66b0e35b.svg";